import type { Request } from '@/types/requests/request'
import { formatWorkloadHours } from '@/utils/format-workload-hours'

export const useResultTable = (request?: Request) => {
  let approvedWorkload = 0
  const previousCourses =
    request?.previousEducation.previousEducationCourses || []
  previousCourses.forEach((course) => {
    approvedWorkload += course.workload
  })

  const courses = request?.previousEducation.previousEducationCourses

  const previousCourseInfo = [
    {
      label: 'NOME DA IES: ',
      value: request?.previousEducation.institution
    },
    {
      label: 'Curso: ',
      value: request?.previousEducation.name
    },
    {
      label: 'Carga Horária Total: ',
      value: formatWorkloadHours(request?.previousEducation.totalWorkload)
    },
    {
      label: 'Carga Horária Aprovada: ',
      value: formatWorkloadHours(approvedWorkload)
    }
  ]

  return { states: { previousCourseInfo, courses } }
}
